// extracted by mini-css-extract-plugin
export var button = "_go-0";